var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-wrapper"},[_c('h1',[_vm._v(_vm._s(_vm.$t('common.privacy_policy')))]),_vm._v(" "),_c('div',{staticClass:"content-block"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('privacy_policy_text'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }